function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/@babel/runtime/helpers/arrayLikeToArray.js
// module id = 119
// module chunks = 0